import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
  Inject,
  Optional,
} from '@angular/core';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {
  ButtonComponent,
  ButtonTextDirective,
} from '../../button/button.component';
import { Router } from '@angular/router';

export interface OfflineDialogData {
  showCacheError?: boolean;
}

@Component({
  selector: 'app-offline-dialog',
  templateUrl: './offline-dialog.component.html',
  imports: [
    MatIconModule,
    MatDialogModule,
    ButtonComponent,
    ButtonTextDirective,
  ],
  styleUrls: ['../modal.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineDialogComponent {
  #dialogRef = inject(MatDialogRef);
  #router = inject(Router);

  showCacheError = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: OfflineDialogData
  ) {
    this.showCacheError = data?.showCacheError ?? false;
  }

  closeDialog(): void {
    this.#dialogRef.close();
  }

  goToPos(): void {
    this.#router.navigate(['/registers/point-of-sales']).then(() => {
      this.#dialogRef.close();
    });
  }
}

export function openOfflineModal(dialog: MatDialog, showCacheError: boolean = false) {
  return dialog.open(OfflineDialogComponent, {
    id: 'offline-modal',
    disableClose: true,
    data: { showCacheError } as OfflineDialogData,
  });
}